import { useCallback, useMemo, useState } from 'react';
import { openAttachmentInNewTab } from '../utils/download';
import { videoMimeType } from '../utils/fileFormatting';
function toSlide(row) {
    if (row.previewKind === 'video') {
        return {
            type: 'video',
            sources: [{ src: row.url, type: videoMimeType(row.extension) }],
            alt: row.name
        };
    }
    return { type: 'image', src: row.url, alt: row.name };
}
/**
 * Preview click behavior for the table's Preview column (E2E-34…E2E-37):
 * photo/video open the same `PhotoCarousel` (scoped to the currently visible
 * media rows, mirroring `FileHandler`'s own gallery scoping), PDF opens the
 * `PDFViewer` modal, everything else downloads.
 */
export function useAttachmentPreview(visibleRows) {
    const [carouselOpen, setCarouselOpen] = useState(false);
    const [carouselIndex, setCarouselIndex] = useState(0);
    const [pdfOpen, setPdfOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null);
    const mediaRows = useMemo(() => visibleRows.filter((row) => row.previewKind === 'photo' || row.previewKind === 'video'), [visibleRows]);
    const carouselSlides = useMemo(() => mediaRows.map(toSlide), [mediaRows]);
    const handlePreviewClick = useCallback((row) => {
        if (row.previewKind === 'photo' || row.previewKind === 'video') {
            const index = mediaRows.findIndex((mediaRow) => mediaRow.id === row.id);
            setCarouselIndex(Math.max(0, index));
            setCarouselOpen(true);
            return;
        }
        if (row.previewKind === 'pdf') {
            setPdfUrl(row.url);
            setPdfOpen(true);
            return;
        }
        openAttachmentInNewTab(row.url);
    }, [mediaRows]);
    return {
        carouselOpen,
        carouselIndex,
        carouselSlides,
        closeCarousel: useCallback(() => setCarouselOpen(false), []),
        setCarouselIndex,
        pdfOpen,
        pdfUrl,
        closePdf: useCallback(() => setPdfOpen(false), []),
        handlePreviewClick
    };
}
